import { DataType } from "shared/types";

import { CountTypeEnum } from "pages/Dashboard/components/constants";
import { BarCell } from "pages/shared/Dashboard/BarCell";

import Tooltip from "features/components/Tooltip";
import { PRIMARY_CHART_COLOR } from "features/ui/charts/constants";

import HeaderText from "./HeaderText";
import {
  ColumnCellRenderProps,
  ColumnHeaderRenderProps,
  SmartGroupColumnDefinition,
  SmartGroupColumnId,
} from "./types";

export const filteredCountColumn: SmartGroupColumnDefinition = {
  id: SmartGroupColumnId.FILTERED_COUNT,

  getSchema: ({ filteredAccessor }) => ({
    accessor: filteredAccessor,
    label: "",
    dataType: DataType.JSX,
    columnWidth: 130,
  }),

  renderHeader: ({ context }: ColumnHeaderRenderProps) => {
    const { countLabel, countType, eventsPeriod, t } = context;

    const headerText =
      countType === CountTypeEnum.FRC_IMPACT
        ? t("schema:dashboard.frc_tooltip")
        : `${countLabel} ${eventsPeriod}`;

    return (
      <Tooltip title={headerText}>
        <HeaderText text={countLabel} secondaryText={`${eventsPeriod}`} />
      </Tooltip>
    );
  },

  renderCell: ({ row, context }: ColumnCellRenderProps) => {
    const { filteredAccessor, maxFilteredValue, countType } = context;

    return (
      <BarCell
        value={row[filteredAccessor]}
        maxValue={maxFilteredValue}
        barColor={PRIMARY_CHART_COLOR}
        isFRCImpact={countType === CountTypeEnum.FRC_IMPACT}
      />
    );
  },
};
